import { NbJSThemeOptions, DARK_THEME as baseTheme } from '@nebular/theme';

const baseThemeVariables = baseTheme.variables;

export const DARK_THEME: NbJSThemeOptions = {
	name: 'dark',
	base: undefined,
	variables: {
		...baseThemeVariables,
		chartjs: {
			axisLineColor: baseThemeVariables.separator,
			textColor: baseThemeVariables.fgText
		}
	}
};
